<div class="snack-bar" matSnackBarLabel>
  <div class="snack-bar-content">
    <mat-icon [fontIcon]="data.icon || 'info_outline'" [color]="data.color || 'primary'"></mat-icon>
    <span>{{ data.message | translate }}</span>
  </div>
  <div class="mat-mdc-snack-bar-actions mdc-snackbar__actions">
    <button mat-button color="warn" (click)="dismiss()">{{ 'LABEL.DISMISS' | translate }}</button>
  </div>
</div>
